module.exports = __webpack_public_path__ + "img/applicationresults_ry.31d3b44e.jpg";